
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateService } from 'src/app/services/date/date.service';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'time-selector',
  templateUrl: 'time-selector.component.html',
  styleUrls: ['./time-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: TimeSelectorComponent
    },
    {
        provide: NG_VALIDATORS, 
        useExisting: forwardRef(() => TimeSelectorComponent),
        multi: true,
    },
]
})
export class TimeSelectorComponent implements OnInit {
  local:string = "fr-fr";
  hours:string;
  minutes:string;
  @Input()
  title:string;
  day:string;  
  year:string;
  showPicker = false;
  onChange = (value) => {};
  onTouched = () => {};
  onValidationChange: any = () => {};
  @Input()
  value:string | any ;

  touched = false;
  @Input()
  disabled = false;

  @Output() valueChanged = new EventEmitter<string>();

  constructor(private dateService:DateService) {

  }

  ngOnInit(){
  }
  itemClicked(){
    this.showPicker = !this.disabled;
  }

  timeChanged(value){
    // console.log(value);
    this.writeValue(value);
    this.onChange(value);
    this.onValidationChange();
    this.showPicker = false;
    this.valueChanged.emit(value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  writeValue(value: string| any) {
    // console.log(value);
    if(value){
      this.value = this.dateService.formatHour(value);
    }
  }

  registerOnTouched(onTouched: any) {
      this.onTouched = onTouched;
  }

  markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
  }

  validate(control: AbstractControl): ValidationErrors {
      return this.value?null:{invalidLocation:true};
  }

  registerOnValidatorChange?(fn: () => void): void {
      this.onValidationChange = fn;
  }

  inputValidator(): ValidatorFn  {
      return (control:AbstractControl) : ValidationErrors | null => {
          if(!this.value){
              return {label:{value:false}}
          }
          else {
              return null
          }
      };
  }
}
